import { cn } from '../../../lib/utils';

type FileKind = { label: string; tone: string };

const PRIMARY = 'bg-[hsl(var(--h-tone-primary-chip-bg))] text-[hsl(var(--h-tone-primary-chip-fg))]';
const KINDS: Record<string, FileKind> = {
  pdf: { label: 'PDF', tone: 'bg-[hsl(var(--h-tone-danger-chip-bg))] text-[hsl(var(--h-tone-danger-chip-fg))]' },
  xls: { label: 'XLS', tone: 'bg-[hsl(var(--h-tone-success-chip-bg))] text-[hsl(var(--h-tone-success-chip-fg))]' },
  csv: { label: 'CSV', tone: 'bg-[hsl(var(--h-tone-success-chip-bg))] text-[hsl(var(--h-tone-success-chip-fg))]' },
  img: { label: 'IMG', tone: 'bg-[hsl(var(--h-tone-info-chip-bg))] text-[hsl(var(--h-tone-info-chip-fg))]' },
  doc: { label: 'DOC', tone: PRIMARY },
  txt: { label: 'TXT', tone: PRIMARY },
};

/** The short type a document shows (mockup §1 `.ic`): from its media type, else its name. */
export function fileKindOf(mediaType: string, filename = ''): FileKind {
  const name = filename.toLowerCase();
  if (mediaType === 'application/pdf' || name.endsWith('.pdf')) return KINDS.pdf!;
  if (mediaType.startsWith('image/')) return KINDS.img!;
  if (mediaType === 'text/csv' || name.endsWith('.csv')) return KINDS.csv!;
  if (mediaType.includes('spreadsheet') || name.endsWith('.xlsx')) return KINDS.xls!;
  if (mediaType.includes('wordprocessing') || name.endsWith('.docx')) return KINDS.doc!;
  return KINDS.txt!;
}

/** A small tinted tile naming the file type; decorative, the filename beside it carries the meaning. */
export function FileTypeIcon({ mediaType, filename, className }: { mediaType: string; filename?: string; className?: string }) {
  const kind = fileKindOf(mediaType, filename);
  return (
    <span aria-hidden="true"
      className={cn('grid h-[30px] w-[26px] shrink-0 place-items-center rounded-[4px] text-[9px] font-extrabold', kind.tone, className)}>
      {kind.label}
    </span>
  );
}
